export default (value) => {
  const abs = Math.abs(value);
  const v = abs || 0;
  const r = v % 100;
  const l = Math.round((v - r) / 100);
  const rs = r < 10 ? `0${r}` : r;
  return `${value < 0 ? '-' : ''}${l},${rs} €`;
};
